import React, { FC } from "react"
import { up } from "styled-breakpoints"
import styled, { css } from "styled-components"
import "swiper/css"

import { BaseImage } from "../image/base-image"
import Slider from "../image-slider"

export interface ILogoWall {
  className?: string
  dark?: boolean
  data?: Array<ILogo>
}

export interface ILogo {
  image: Queries.WpMediaItem
}

const Wrapper = styled.div<ILogoWall>`
  display: none;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px 40px;
  place-items: center;
  max-width: 1200px;
  padding: 45px 40px;
  margin: 0 auto;

  ${up("md")} {
    display: grid;
    gap: 16px 30px;
  }

  ${up("lg")} {
    gap: 16px 80px;
  }

  ${(props) =>
    props.dark &&
    css`
      ${Logo} {
        filter: brightness(0) invert(1);
      }
    `}

  /* First logo in series is outsized (design issue) */
  > div:nth-child(1) {
    max-width: 140px;
  }
`

const Logo = styled(BaseImage)`
  max-width: 140px;

  ${up("lg")} {
    max-width: 160px;
    height: 56px;
  }
`

const SwiperWrapperShadowOverlayStyle = css`
  position: absolute;
  top: -2px;
  z-index: 5;
  display: block;
  width: 55px;
  height: 100%;
  pointer-events: none;
  content: "";
  transition: opacity 150ms ease;
`

const StyledSlider = styled(Slider)`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: auto;

  &::before {
    ${SwiperWrapperShadowOverlayStyle}

    left: -16px;
    background: linear-gradient(90deg, rgb(2 4 22 / 100%), rgb(2 4 22 / 0%));
  }

  &::after {
    ${SwiperWrapperShadowOverlayStyle}

    right: -16px;
    background: linear-gradient(-90deg, rgb(2 4 22 / 100%), rgb(2 4 22 / 0%));
  }

  ${up("md")} {
    display: none !important;
  }
`

export const LogoWall: FC<ILogoWall> = (props) => {
  const { className, dark, data } = props

  if (!data) return null

  return (
    <>
      <StyledSlider
        autoplay={true}
        gap={{ default: 10 }}
        width={{ default: 140 }}>
        {data?.map((item: any, index: number) => (
          <Logo image={item.image} key={`logo-img-${index}`} />
        ))}
      </StyledSlider>
      <Wrapper className={className ?? ""} dark={dark}>
        {data?.map((item: any, index: number) => (
          <Logo image={item.image} key={`logo-img-${index}`} />
        ))}
      </Wrapper>
    </>
  )
}
